
import {
invoiceTitleType,
discernStatus,
invoiceCheckStatus
} from "@/common/js/const";
import {setToken, getToken} from "@/common/js/common.js";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


import  scrollerEdit from '../invoice/scroller-edit'
export default {
directives: {
TransferDom
},
components: {
Box,
XInput,
Group,
Tabbar,
CheckIcon,
TabbarItem,
PopupPicker,
Datetime,
Scroller,
scrollerEdit,
Spinner,
Cell,
CellBox,
XHeader,
Loading,
Flexbox,
FlexboxItem
},
data() {
return {
showLoading: false,
groupFlag: "",
appKey: "",
mobilePhone: "",
selected: false,
code: '',
deviceId: '',
period: 1,
isWechat: ____isWechatBrowser(),
showInvoiceTypePicker: false,
periodTypePickerValue: [],
invoiceList: [
[
{
name: "全部发票",
value: ""
},
{
name: "普通电票",
value: "1"
},
{
name: "通行费电票",
value: "2"
},
{
name: "区块链电票",
value: "3"
}
]
],
showInvoiceStatusPicker: false,
StatusPickerValue: [],
invoiceStatusList: [
[
{
name: "所有类型",
value: ""
},
{
name: "可打印",
value: "1"
},
{
name: "已验证",
value: "2"
},
{
name: "已报销",
value: "3"
}
]
],
invoices: [],
scrollerHeight:
____invoiceScrollerHeight -
(this.$route.meta.showTabbar ? 55 : 0) +
"px",
scrollerStatus: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupEnabled: true,
scrollerPullupConfig: {
content: this.$t("上拉加载更多"),
downContent: this.$t("松开加载"),
upContent: this.$t("上拉加载更多"),
loadingContent: this.$t("加载中"),
height: 0,
autoRefresh: false
},
scrollerPulldownConfig: {
content: this.$t("下拉刷新"),
downContent: this.$t("松开刷新"),
upContent: this.$t("松开刷新"),
loadingContent: this.$t("加载中"),
height: 100,
autoRefresh: false
},
search: {
companyName: '',
invoiceType: this.$t("发票类型"),
typeId: "",
invoiceStatus: this.$t("发票状态"),
statusId: "",
date: this.$dateFormat(new Date(), 'YYYYMMDD'),
dateDisplayName: this.$dateFormat(new Date(), 'YYYY-MM'), //this.$t("日期"),
pageNo: 1,
pageSize: 10
},
jsApiSign: {},
browserType: "mobile"
};
},
created() {

},
activated() {

this.browserType = ____browserRedirect();

if (this.isWechat) {

this.$webapi.getJsapiSign().then(res => {
if (res.data) {
this.jsApiSign = res.data;
}
window.wx.config({
beta: true,
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

"chooseInvoice"
]
});
});

}

},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {
this.code = this.$route.query.code;
this.groupFlag = this.$route.query.br;
this.deviceId = window.localStorage.getItem("deviceId");
this.$nextTick(() => {
this.$refs.scroller1.reset({top: 0});
});
this.loadData(true);
},
methods: {


loadMore() {
this.loadData(false, () => {
setTimeout(() => {
this.$refs.scroller1.donePullup();
}, 1200);
});
},

refresh() {
this.loadData(true, () => {
setTimeout(() => {
this.$nextTick(() => {
setTimeout(() => {
this.$refs.scroller1.donePulldown();
this.pullupEnabled && this.$refs.scroller1.enablePullup();
}, 10);
});
}, 1200);
});
},

loadData(firstLoad, callback) {
if (firstLoad) {
this.search.pageNo = 1;
} else {
this.search.pageNo += 1;
}
var params = {
code: this.code,
state: this.groupFlag,
invoiceType: this.search.typeId,
invoiceStatus: this.search.statusId,
pageNo: this.search.pageNo,
pageSize: this.search.pageSize,
invoiceTime: this.search.date,
purchaserName: this.search.companyName
};

this.showLoading = true;
this.$webapi.queryPrintInvoiceList(params).then(res => {
this.showLoading = false;
if (res.status === 200 && res.data.status == 1) {
if (res.data.result && res.data.result.list.length == 0) {


if (!firstLoad) {
this.search.pageNo--;
}
}
let tempInvoices = res.data.result ? res.data.result.list : [];
tempInvoices.forEach(item => {
item.selected = false;
})
if (firstLoad) {
this.invoices = tempInvoices;
} else {
this.invoices = this.invoices.concat(tempInvoices);
}
} else {

if (!firstLoad) {
this.search.pageNo--;
}
}

if (callback) {
callback();
}
});
},

searchByCompanyName() {
if (this.search.companyName.length >= 2 || this.search.companyName.length === 0) {
this.loadData(true);
}
},

onInvoiceTypePickerChange(val) {
this.search.typeId = val[0];
this.search.invoiceType = this.invoiceList[0].filter(el => {
return el.value == this.search.typeId;
})[0].name;
this.$nextTick(() => {
this.loadData(true);
})
},


onInvoiceStatusPickerChange(val) {
this.search.statusId = val[0];
this.search.invoiceStatus = this.invoiceStatusList[0].filter(el => {
return el.value == this.search.statusId;
})[0].name;
this.$nextTick(() => {
this.loadData(true);
})
},


showDatePicker() {
this.$vux.datetime.show({
cancelText: this.$t('取消'),
confirmText: this.$t('确定'),
format: 'YYYY-MM',
value: this.search.dateDisplayName,
onConfirm: val => {
this.search.date = val.replace(/-/g, '') + '01';
this.search.dateDisplayName = val;
this.$nextTick(() => {
this.loadData(true);
})
},
});
},

pageGoBack() {
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {
window.iosApi.backCalls();
}
} catch (error) {
this.$router.go(-1);
}
},
clearCompanyName() {
this.loadData(true)
},


showCardList() {
window.wx.ready(() => {
window.wx.invoke('chooseInvoice', {
'timestamp': this.jsApiSign.timestamp,
'nonceStr': this.jsApiSign.nonceStr,
}, (res) => {
this.getCardInvoiceDetails(res);
})
});
},


getCardInvoiceDetails(res) {
let params = {};
params.cards = JSON.parse(res.choose_invoice_info);
params.code = this.code;
params.state = this.groupFlag;
this.$webapi.pullCardInvoices(params).then(result => {
if (result.status === 200) {
let res = result.data;
if (res.code === 1) {
this.loadData(true);
} else {
this.showAlert(res.msg);
}
}
})
},


printInvoice() {
let selectedInvoicePDFs = this.invoices.filter(item => {
return item.selected;
}).map(item => {
return item.pdfUrl;
})
if (selectedInvoicePDFs.length === 0) {
this.$vux.alert.show({
title: '',
content: '请选择需要打印的发票',
});
return;
}
let params = {
pdfs: selectedInvoicePDFs,
deviceId: this.deviceId,
userId: this.invoices[0].userId
}
this.showLoading = true;
this.$webapi.printInvoices(params).then(result => {
if (result.status === 200) {
let res = result.data;
if (res.status == 1) {
this.loadData(true);
}
this.$vux.alert.show({
title: '',
content: res.msg,
});
} else {
this.$vux.alert.show({
title: '',
content: '打印发票失败',
});
}

this.showLoading = false;
})
},
deleteInvoices() {
let selectedInvoices = this.invoices.filter(item => {
return item.selected;
}).map(item => {
return {invoiceNo: item.invoiceNo, invoiceCode: item.invoiceCode};
})
if (selectedInvoices.length === 0) {
this.$vux.alert.show({
title: '',
content: '请选择需要删除的发票',
});
return;
}
let params = {
invoices: selectedInvoices,
userId: this.invoices[0].userId
}
this.showLoading = true;
this.$webapi.deleteInvoices(params).then(result => {
if (result.status === 200) {
let res = result.data;
if (res.status == 1) {
this.loadData(true);
}
this.$vux.alert.show({
title: '',
content: res.msg,
});
} else {
this.$vux.alert.show({
title: '',
content: '删除发票失败',
});
}
this.showLoading = false;
})
},

checkRecord(record) {
let selectedInvoice = this.invoices.filter(item => {
return item.selected;
})
if (selectedInvoice.length >= 10) {
this.$vux.alert.show({
title: '',
content: '最多只能选择10张发票进行打印',

});
return;
}
if (record.canPrint) {
record.selected = !record.selected;
}
}
}
};
